const styles = () => ({
    flex: {
        flex: 1
    },
    appBar: {
        position: 'static'
    },
    contentRoot: {
        padding: 0,
        minHeight: 370,
        minWidth: 350
    },
    dialogOpen: {
        overflowY: 'auto'
    },
});

export default styles;